import { supabase } from '@/lib/supabase';
import type { MaterialCategoryRow } from '@/types/database';

/**
 * Material categories are designer-owned rows (migration 0019), seeded with a
 * default set and extendable inline from the material modal — the same shape
 * as room types.
 */
export async function listMaterialCategories(): Promise<MaterialCategoryRow[]> {
  const { data, error } = await supabase
    .from('material_categories')
    .select('*')
    .order('sort_order', { ascending: true })
    .order('name', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

/**
 * Add a custom category for the signed-in designer.
 *
 * sort_order puts it after the seeded defaults (which stop at 12) so a
 * designer's own additions collect at the end rather than interleaving.
 */
export async function createMaterialCategory(name: string): Promise<MaterialCategoryRow> {
  const { data: session } = await supabase.auth.getUser();
  const designerId = session.user?.id;
  if (!designerId) throw new Error('Not signed in');

  const { data, error } = await supabase
    .from('material_categories')
    .insert({ designer_id: designerId, name: name.trim(), sort_order: 100 })
    .select()
    .single();
  if (error) throw error;
  return data as MaterialCategoryRow;
}

export async function deleteMaterialCategory(id: string): Promise<void> {
  // specs.material_category_id is `on delete set null`, so materials survive
  // and simply show no category.
  const { error } = await supabase.from('material_categories').delete().eq('id', id);
  if (error) throw error;
}
